import React, {Component} from 'react'
import { Redirect } from 'react-router-dom'
import Loading from './Loading'
import {app}  from '../base'

class Logout extends Component {
    constructor() {
        super()
        this.state = {
            redirect:false
        }
    }
    componentWillMount() {
        app.auth().signOut().then((user) => {
            this.setState({redirect:true})
        }
        )
    }
    render() {

            if(this.state.redirect === true) {
                return <Redirect to="/" />
            }
            return (
                <Loading />
            )

    }
}

export default Logout


// WEBPACK FOOTER //
// ./src/components/Logout.jsx